import { SelectPartner } from "@/features/partner"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { selectCurrentPartner, setSelectedPartner } from "../../model"
import { CreateDiscount } from "../create-discount"

export const DiscountsFilters = () => {
    const dispatch = useAppDispatch()
    const partnerId = useAppSelector(selectCurrentPartner)

    const handleSelectPartner = (value: string | null) => {
        dispatch(setSelectedPartner(value))
    }

    return (
        <div className="flex w-full gap-2">
            <SelectPartner value={partnerId} onChange={handleSelectPartner} />
            <CreateDiscount />
        </div>
    )
}